"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var BarScaleCalculator = /** @class */ (function () {
    function BarScaleCalculator(rawData, getRowValue, options) {
        this.rawData = rawData;
        this.getRowValue = getRowValue;
        this.options = options;
        this.zeroAxisPosition = 'diff';
        this.applyNegativeModifier = false;
        this.domain = this.getDomain();
        this.workingData = this.getWorkingData();
        this.lineX = this.getLineX();
    }
    BarScaleCalculator.prototype.getPropsForDataIndex = function (index, optionOverrides) {
        if (optionOverrides === void 0) { optionOverrides = {}; }
        if (this.workingData.length > index && index >= 0) {
            var data = this.workingData[index];
            var width = this.getItemWidth(data.calcValue, false);
            var height = this.options.container.height - this.options.container.padding.vertical;
            var x = this.getItemX(width, this.lineX);
            return {
                container: ksys_app_template_1.utils.object.deepMergeObjectsWithOptions({ arrayMergeStrategy: 'DeepCopy' }, this.options.container, optionOverrides.container),
                line: __assign(__assign({}, ksys_app_template_1.utils.object.deepMergeObjectsWithOptions({ arrayMergeStrategy: 'DeepCopy' }, this.options.line, optionOverrides.line)), { x: this.lineX }),
                rect: __assign(__assign({}, ksys_app_template_1.utils.object.deepMergeObjectsWithOptions({ arrayMergeStrategy: 'DeepCopy' }, this.options.rect, optionOverrides.rect)), { width: width,
                    height: height,
                    x: x }),
                label: __assign(__assign({}, ksys_app_template_1.utils.object.deepMergeObjectsWithOptions({ arrayMergeStrategy: 'DeepCopy' }, this.options.label, optionOverrides.label)), { text: data.origValue.toString() }),
            };
        }
        return;
    };
    BarScaleCalculator.prototype.getItemX = function (width, relativeX) {
        switch (this.zeroAxisPosition) {
            case 'diff':
                if (relativeX) {
                    return width < 0 ? relativeX + width : relativeX;
                }
                return width;
            case 'right':
                return this.options.container.width - width;
            case 'left':
            default:
                return 0;
        }
    };
    BarScaleCalculator.prototype.getItemWidth = function (dataPoint, applyAbsolute) {
        if (applyAbsolute === void 0) { applyAbsolute = true; }
        if (dataPoint !== 0) {
            var percentage = dataPoint / this.domain.size;
            if (this.zeroAxisPosition === 'diff') {
                if (applyAbsolute) {
                    return Math.abs(percentage * (this.options.container.width - this.options.container.padding.horizontal * 2));
                }
                return percentage * (this.options.container.width - this.options.container.padding.horizontal * 2);
            }
            return percentage * (this.options.container.width - this.options.container.padding.horizontal);
        }
        return dataPoint;
    };
    BarScaleCalculator.prototype.getLineX = function () {
        var lineX = 0;
        switch (this.zeroAxisPosition) {
            case 'diff':
                var minWidth = this.getItemWidth(this.domain.min);
                lineX = this.getItemX(minWidth) + this.options.container.padding.horizontal;
                break;
            case 'right':
                lineX = this.options.container.width;
                break;
            case 'left':
            default:
                lineX = 0;
        }
        return lineX;
    };
    BarScaleCalculator.prototype.isNumber = function (value) {
        return typeof value === 'number';
    };
    BarScaleCalculator.prototype.getWorkingData = function () {
        var _this = this;
        return this.rawData.map(function (d) {
            var value = _this.getRowValue(d);
            if (_this.isNumber(value) && value !== 0) {
                if (_this.applyNegativeModifier) {
                    if (_this.zeroAxisPosition === 'right') {
                        return { calcValue: Math.abs(value), origValue: value };
                    }
                }
            }
            else if (!_this.isNumber(value)) {
                value = 0;
            }
            return { calcValue: value, origValue: value };
        });
    };
    BarScaleCalculator.prototype.getDomain = function () {
        var max = this.findDomainKey('max');
        var min = this.findDomainKey('min');
        var absoluteMax = Math.abs(max);
        var absoluteMin = Math.abs(min);
        var size = 0;
        if (min < 0 && max <= 0) {
            this.applyNegativeModifier = true;
            this.zeroAxisPosition = 'right';
            size = absoluteMin;
        }
        else if (min >= 0 && max > 0) {
            this.zeroAxisPosition = 'left';
            size = absoluteMax;
        }
        else if (min < 0 && max > 0) {
            this.applyNegativeModifier = true;
            this.zeroAxisPosition = 'diff';
            size = absoluteMin + absoluteMax;
        }
        return {
            max: max,
            min: min,
            absoluteMax: absoluteMax,
            absoluteMin: absoluteMin,
            size: size,
        };
    };
    BarScaleCalculator.prototype.findDomainKey = function (key) {
        return this.rawData.reduce(function (m, c) {
            if (key === 'min') {
                return c.value < m ? c.value : m;
            }
            return c.value > m ? c.value : m;
        }, this.rawData[0].value);
    };
    return BarScaleCalculator;
}());
exports.BarScaleCalculator = BarScaleCalculator;
